export default "__VITE_ASSET__CTwEV89J__"